const SCROLL_OPTIONS = { offset: -100 };

export function goToHomeSection(vm, selector) {
  if (!vm || !selector) {
    return Promise.resolve();
  }

  const scroll = () => {
    if (typeof vm.$scrollTo === 'function') {
      vm.$scrollTo(selector, 500, SCROLL_OPTIONS);
    }
  };

  if (vm.$route.name !== 'home') {
    return vm.$router.push({ name: 'home' }).then(() => vm.$nextTick(scroll));
  }

  scroll();
  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/utils/homeSectionNav.js